export default "__VITE_ASSET__QdB1XYcq__"